<template>
    <b-modal ref="edit-employee-modal"
             hide-footer
             scrollable
             no-close-on-backdrop
             size="lg"
             :title="$t('employee-edit')">

        <div v-if="employee" class="panel">
            <div class="row mb-2">
                <div class="col-12 col-sm-6">
                    <label>{{ $t("#TR-restaurants") }}</label>
                    <b-dropdown
                        block
                        split-variant="outline-success"
                        variant="success"
                        disabled
                        :text="selectedRest.name"
                        menu-class="w-100"
                        class="w-100">
                        <b-dropdown-item
                            v-for="rest in restList"
                            :key="rest['sifr']"
                            href="#"
                            @click="selectRest(rest)">
                            {{ rest.name }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="col-12 col-sm-6">
                    <label>{{ $t("#TR-roles") }}</label>
                    <b-dropdown
                        block
                        :disabled="!selectedRest.guid"
                        split-variant="outline-success"
                        variant="success"
                        :text="selectedRole.name"
                        menu-class="w-100"
                        class="w-100">
                        <b-dropdown-item
                            v-for="role in roleList"
                            :key="role['sifr']"
                            href="#"
                            @click="selectRole(role)">
                            {{ role.name }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-12 col-sm-6">
                    <label> {{ $t("#TR-name") }}:</label>
                    <b-form-input v-model="employee['name']"></b-form-input>
                </div>
                <div class="col-12 col-sm-6">
                    <label> {{ $t("#TR-card-code") }}:</label>
                    <b-form-input v-model="employee['cardCode']"></b-form-input>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-12 col-sm-6">
                    <label> {{ $t("#TR-password") }}:</label>
                    <b-form-input v-model="password.new"
                                  type="password"
                                  autocomplete="new-password"
                                  :placeholder="password.placeholder"
                                  :state="password.noError"
                                  @focusin="focusInPassword"
                                  @keyup="comparePassword">
                    </b-form-input>
                </div>
                <div class="col-12 col-sm-6">
                    <label> {{ $t("#TR-confirm-password") }}:</label>
                    <b-form-input v-model="password.confirm"
                                  type="password"
                                  autocomplete="new-password"
                                  :disabled="password.confirmDisable"
                                  :state="password.noError"
                                  @keyup="comparePassword">
                    </b-form-input>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12 text-center">
                    <b-button
                        variant="danger"
                        type="button"
                        class="mx-1"
                        @click="cancel">
                        <span class="mdi mdi-close mr-1"></span> {{ $t("#TR-cancel") }}
                    </b-button>
                    <b-button
                        variant="success"
                        type="button"
                        class="mx-1"
                        @click="onSave()">
                        <span class="mdi mdi-content-save"></span> {{ $t("#TR-save") }}
                    </b-button>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12 text-center">
                    <b-alert :show="formError.length > 0"
                             variant="danger"
                             class="mb-0">
                        <ul class="small mb-0">
                            <li v-for="(err, idx ) in formError" :key="idx">{{ err }}</li>
                        </ul>
                    </b-alert>

                </div>
            </div>


        </div>
    </b-modal>
</template>

<script>
import { ApiEditor } from '@/services/api';
import MSG from '@/services/notify';

export default {
    name: 'EmployeeEdit',
    props: {
        editableEmployee: {
            default: () => {
                return null;
            },
            type: Object
        },
        employeeFilter: {
            default: () => {
                return null;
            },
            type: Object
        }
    },

    data() {
        return {
            employee: null,
            restList: [],
            roleList: [],
            password: {
                new: null,
                confirm: null,
                placeholder: '******',
                confirmDisable: true,
                noError: null
            },
            selectedRest: this.employeeFilter.selectedRest,
            selectedRole: this.employeeFilter.selectedRole,
            formError: []
        };
    },

    async mounted() {
        await this.getEmployee();
        // todo_ldw убрать запрос ресторана ролей
        // await this.getRests();
        await this.getRoles(this.selectedRest.sifr);
        this.employee.parent = this.selectedRole.sifr;
    },

    methods: {
        comparePassword() {
            this.password.noError = false;

            if (this.password.new) {
                this.password.new.trim();
                this.password.confirmDisable = false;
            }

            if (this.password.confirm) {
                this.password.confirm.trim();
            }

            if (!this.password.new) {
                this.password.confirm = null;
            }

            this.password.noError = this.password.new === this.password.confirm;

            if (!this.password.new && !this.password.confirm) {
                this.password.noError = null;
                this.password.placeholder = '*****';
                this.password.confirmDisable = true;
            }
        },

        focusInPassword() {
            this.password.placeholder = null;
            this.password.confirmDisable = false;
        },

        async getEmployee() {
            if (this.editableEmployee.guid) {
                const result = await ApiEditor.getEmployees(this.editableEmployee.guid);
                this.employee = result.data;
            } else {
                this.employee = {
                    cardCode: null,
                    password: null,
                    code: null,
                    sifr: null,
                    name: null
                };
            }
        },

        async getRests() {
            const result = await ApiEditor.getRest();
            this.restList = result.data;
        },

        async getRoles(sifr) {
            const result = await ApiEditor.getRestRole(sifr);
            this.roleList = result.data;
        },

        selectRest(rest) {
            this.selectedRest = rest;
            this.selectedRole = {
                name: this.$t('#TR-select'),
                guid: null,
                sifr: null
            };
            this.getRoles(this.selectedRest.sifr);
        },

        selectRole(role) {
            this.selectedRole = role;
            this.employee.parent = this.selectedRole.sifr;
        },

        cancel() {
            this.$refs['edit-employee-modal'].hide();
            this.$emit('cancelViewEdit');
        },

        openEmployeeEdit() {
            this.$refs['edit-employee-modal'].show();
        },

        async onSave() {
            this.employee.password = null;
            this.formError = this.validateEmployee();

            if (this.formError.length > 0) {
                return;
            }

            if (this.password.new) {
                this.employee.password = this.password.new;
            }

            delete this.employee.sifr;
            delete this.employee.code;

            let result = {};
            if (this.employee.guid) {
                result = await ApiEditor.updateEmployee(this.employee);
            } else {
                result = await ApiEditor.addEmployee(this.employee);
            }

            if (!result.error) {
                MSG.success('Employee saved', this);
                this.$emit('employeeSaved');
            } else {
                MSG.error(result.error, this);
            }

            this.$refs['edit-employee-modal'].hide();
            this.$emit('cancelViewEdit');
        },

        validateEmployee() {
            const error = [];

            if (!this.employee.name) {
                error.push('Enter name');
            }

            if (this.password.new) {
                if (!this.password.noError) {
                    error.push('Password Error');
                }
            }

            return error;
        }

    }
};
</script>

<style lang="stylus" scoped>

</style>
